import { legoTheme } from "@/constants/theme/lego";
// import logo from "../assets/lego/LEGO_F1-Logo.png";
// import appicon from "../assets/lego/lego_appicon.webp";
// import challengesCover from "../assets/lego/lego_challenges_cover.webp";

export const lego = {
  name: "LEGO",
  logos: {
    large: null,
    white: null,
    small: null,
    favicon: "",
    alt: "LEGO logo",
  },
  images: {
    cover: {
      challenges: null,
    },
  },
  tenantId: "LEGO-gdjkr",
  theme: legoTheme,
  defaultLanguage: "en",
  meta: {
    title: "Lego",
    description: "",
  },
  autoJoinChallenge: true,

  hasFeature: {
    notifications: false,
    themes: false,
    connections: false,
    achievements: false,
    messages: false,
    teams: false,
    news: false,
    challenges: true,
    singleChallenge: true,
    preferences: false,
    friends: false,
    zones: false,
    feed: true,
    posts: false,
    winners: false, // !! Also add the data variables for this feature in brandVariables.tsx !!
    schedule: false, // !! Also add the data variables for this feature in brandVariables.tsx !!
    qrSignUp: true,
    manualSubmissions: false,
    landing: true,
    login: true,
    haslanguagePicker: true,
    getstarted: false,
    hero: false,
    search: false,
    routes: false,
    dailytasks: false,
    games: false,
    treasure_hunt: false,
    activities: false,
    changePassword: true,
    feedback: false,
    events: false,
  },
  hasAuth: {
    steam: false,
    bnet: false,
    quickSignUp: true,
    google: false,
    discord: false,
    twitch: false,
  },
  hasCreate: {
    studio: false,
    challenges: false,
    news: false,
  },
};
